<template>
  <v-modal
    v-model="model"
    blockScroll
    handleClickBg
    :animation="!screen.breakPoint.tabPort ? 'slide-up' : 'slide-down'"
    :position="!screen.breakPoint.tabPort ? 'bottom' : null"
    :full="!screen.breakPoint.tabPort"
    :fit-content="!screen.breakPoint.tabPort"
    no-target
  >
    <template v-slot:header>
      {{ $t('widgets.ConfirmModal.confirmAction') }}
    </template>
    <div class="my-2" style="max-width: 40rem;">{{ message }}</div>
    <template v-slot:footer>
      <div class="d-flex justify-end">
        <v-button @click="decline()" inline>{{ $t('widgets.ConfirmModal.cancel') }}</v-button>
        <v-button @click="accept()" color="success" class="ml-2">{{ $t('widgets.ConfirmModal.confirm') }}</v-button>
      </div>
    </template>
  </v-modal>
</template>

<script>
import { getters, mutations } from '@/store'

import vModal from '@/ui/modals/vModal'
import vButton from '@/ui/controls/vButton'

import screen from '@/mixins/screen'

export default {
  name: 'confirm-modal',
  components: {
    vModal,
    vButton
  },
  mixins: [screen],
  computed: {
    ...getters,
    model: {
      get () {
        return this.showConfirmModal
      },

      set (val) {
        if (val === false) {
          this.decline()
        }
      }
    }
  },
  methods: {
    ...mutations,
    accept () {
      this.ACCEPT()
    },

    decline () {
      this.DECLINE()
      this.CLEAR()
    }
  }
}
</script>
